/**
 * <ActivationLandingSkeleton> — la forme de l'arrivée du lien d'activation pendant son chargement.
 *
 * Le cas que le lien sert d'abord — une suite à activer : l'en-tête de l'élève, la carte du
 * produit (son nom, sa ligne de fin), puis la carte « Et ensuite ? » et ses deux gestes. Mêmes
 * surfaces que la page, dans la même colonne.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { ActivationStudentHeaderSkeleton } from "../../molecules/ActivationStudentHeader/ActivationStudentHeaderSkeleton"
import { Card } from "../../molecules/Card"
import { SubscriptionNextStepCardSkeleton } from "../../organisms/SubscriptionNextStepCard/SubscriptionNextStepCardSkeleton"

export function ActivationLandingSkeleton() {
    return (
        <Stack gap="3">
            <ActivationStudentHeaderSkeleton />
            <Card p="4">
                <Stack gap="1">
                    <Skeleton textSize="text-md" width={190} />
                    <Skeleton textSize="text-sm" width={150} />
                </Stack>
            </Card>
            <SubscriptionNextStepCardSkeleton />
        </Stack>
    )
}
